import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useNavigate } from "react-router-dom";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import LeadCardDetails from "../leadcarddetails/LeadCardDetails";

const LeadDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    return (
        <div>
            <StatusCard
                leftContent="Lead Details" 
            />
            <LeadCardDetails item = {state}/>

        </div>

    )
}
export default LeadDetails;








